import { render } from "./ViewBankAccount.vue?vue&type=template&id=50867ae8"
import script from "./ViewBankAccount.vue?vue&type=script&lang=js"
export * from "./ViewBankAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__